module.exports = __webpack_public_path__ + "img/30.ae2b5d96.png";